import { NgModule } from '@angular/core';
import {
    RouterModule,
    Routes,
} from '@angular/router';
import { ChoosePinComponent } from './choose-pin/choose-pin.component';
import { ConfirmPinComponent } from './confirm-pin/confirm-pin.component';
import { EnterPinComponent } from './enter-pin/enter-pin.component';
import { PinIncorrectComponent } from './pin-incorrect/pin-incorrect.component';
import { PinMismatchComponent } from './pin-mismatch/pin-mismatch.component';

const routes: Routes = [
    {
        path: '',
        // component: LoginComponent,
        children: [
            {
                path: 'choose-pin',
                component: ChoosePinComponent,
            },
            {
                path: 'confirm-pin',
                component: ConfirmPinComponent,
            },
            {
                path: 'enter-pin',
                component: EnterPinComponent,
            },
            {
                path: 'pin-mismatch',
                component: PinMismatchComponent,
            },
            {
                path: 'pin-incorrect',
                component: PinIncorrectComponent,
            },
        ],
    },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class TicketRedemptionRoutingModule { }
